/**
 * @file PRO Admin Custom Prints related queries.
 */

import gql from 'graphql-tag';

import { PurchasedCustomPrintFields } from '../fragments/pro-custom-prints';

export const PurchasedCustomPrint = gql`
  query purchasedCustomPrint($id: RecordID!) {
    purchasedCustomPrint(id: $id) {
      id
      ...PurchasedCustomPrintFields
      transaction {
        id
        email_address
        transaction_items {
          total
          records {
            __typename
            ... on ITransactionItem {
              id
              item_type
              price {
                value
                currency
              }
              total_price {
                value
                currency
              }
              tax_price {
                value
                currency
              }
              tax_total_price {
                value
                currency
              }
              vendor_local_tax_price {
                value
                currency
              }
              vendor_state_tax_price {
                value
                currency
              }
              item_shipping_price {
                value
                currency
              }
              print_partner_cost_total_price {
                value
                currency
              }
              waldo_fee {
                value
                currency
              }
              waldo_fee_price {
                value
                currency
              }
              waldo_app_fee_price {
                value
                currency
              }
              stripe_fee_price {
                value
                currency
              }
              transaction_refunds(slice: { limit: 999 }) {
                records {
                  id
                  amount
                  notes
                  account {
                    id
                  }
                }
              }
              transaction {
                id
                uuid
                total
                vendor_can_reprint
                stripe_connect_account_id
                payment_processor_transaction_id
                bayphoto_lookup_id
                roes_order_id
                account_address {
                  id
                  name
                  address_line_1
                  address_line_2
                  city
                  state
                  post_code
                  country {
                    id
                    name
                  }
                }
                transaction_refunds(slice: { limit: 999 }) {
                  records {
                    id
                    amount
                    notes
                    account {
                      id
                    }
                  }
                }
                print_partner {
                  id
                  name
                  contact_phone_number
                  contact_email_address
                  roes_info {
                    lab_id
                  }
                }
              }
            }
            ... on TransactionCustomPrintAlbumItem {
              purchased_custom_print {
                id
              }
            }
            ... on ITransactionPhotoItem {
              photo_item_type
              album {
                id
                name
                root_album_folder {
                  id
                  name
                }
              }
              photo {
                id
              }
            }
            ... on TransactionPhotoPrintPackageItem {
              quantity
              print_package {
                id
                items {
                  total
                  records {
                    id
                    custom_print {
                      id
                    }
                  }
                }
              }
              print_package_name
              identity {
                id
              }
              identity_name
              print_without_watermark
              digital_downloads_purchase
              print_package_price {
                value
                currency
              }
              digital_downloads_price {
                value
                currency
              }
              album_folder_tag {
                ... on IRecord {
                  id
                }
              }
              album_folder_tag_name
              album_folder_tag_price {
                value
                currency
              }
              shipping_cost_percentage
              tax_percentage
              print_items {
                total
                records {
                  quantity
                  print_package_item_type {
                    id
                  }
                  print_package_item_type_name
                }
              }
              accounting_codes
            }
          }
        }
        purchased_custom_prints(slice: { limit: 999 }) {
          total
          records {
            ...PurchasedCustomPrintFields
          }
        }
      }
    }
  }
  ${PurchasedCustomPrintFields}
`;
